import { ListItem, ListItemIcon, ListItemText } from "@mui/material";
import React from "react";

export type MenuButtonProps = {
    text: string,
    icon?: React.ReactElement,
    selected?: boolean
    onclick?: any
}

export function MenuButton({ text, icon, onclick }: MenuButtonProps) {
    return (
        <ListItem button
            key="DataModel"
            sx={{
                py: 0,
                minHeight: 32,
                width: 200,
                pl: '8px'
            }}
            onClick={onclick}
        >
            <ListItemIcon>
                {icon}
            </ListItemIcon>
            <ListItemText primary={text} primaryTypographyProps={{ fontSize: 14, fontWeight: 'medium' }} />
        </ListItem>
    );
}

export default MenuButton;